import { useRef, useState } from "react";
import { Upload, X } from "lucide-react";
import { toast } from "sonner";
import { api } from "../../lib/api";
import { formatApiError } from "../../lib/auth";

export const uploadImage = async (file) => {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post("/admin/upload", fd);
  return data.url;
};

export const ImageDrop = ({ label, multiple = false, onUploaded, testId }) => {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);

  const handle = async (files) => {
    setBusy(true);
    try {
      for (const f of Array.from(files)) onUploaded(await uploadImage(f));
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Upload failed");
    } finally {
      setBusy(false);
      if (ref.current) ref.current.value = "";
    }
  };

  return (
    <button
      type="button"
      onClick={() => ref.current?.click()}
      className="w-full border-2 border-dashed border-ink/40 hover:border-hot hover:bg-blush/40 transition-colors py-8 grid place-items-center gap-2"
      data-testid={testId}
    >
      <Upload className="h-5 w-5" />
      <span className="kicker">{busy ? "Uploading…" : label}</span>
      <input ref={ref} type="file" accept="image/jpeg,image/png,image/webp,image/gif" multiple={multiple} hidden onChange={(e) => handle(e.target.files)} data-testid={`${testId}-input`} />
    </button>
  );
};

export const Thumb = ({ src, onRemove, testId }) => (
  <div className="relative group" data-testid={testId}>
    <img src={src} alt="" className="aspect-[4/5] w-full object-cover border-2 border-ink" />
    <button type="button" onClick={onRemove} className="absolute top-2 right-2 h-8 w-8 grid place-items-center bg-ink text-cream hover:bg-rose" aria-label="Remove image" data-testid={`${testId}-remove`}>
      <X className="h-4 w-4" />
    </button>
  </div>
);
